import TForm from './form.vue'
import TFormItem from './form-item.vue'

TForm.Item = TFormItem
export default TForm



// WEBPACK FOOTER //
// ./src/components/form/index.js